import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { SlaVersionCheckComponent } from './sla-version-check.component';
import { VersionCheckDialogComponent } from './version-check-dialog/version-check-dialog.component';

export * from './sla-version-check.component';
export * from './version-check-dialog/version-check-dialog.component';

@NgModule({
    declarations: [ SlaVersionCheckComponent, VersionCheckDialogComponent ],
    imports: [
        CommonModule,
        MatDialogModule,
        TranslateModule,
        MatButtonModule,
        MatIconModule,
    ],
    exports: [ SlaVersionCheckComponent, VersionCheckDialogComponent ],
})
export class SlaVersionCheckModule {}
